module.exports = __webpack_public_path__ + "img/4.3cd291f8.png";